const config = {
  // api: "http://localhost:8083/bravoapi21",
  // cms: "http://localhost:3087",
  // api: 'https://uateapp.generali.com.hk/bravoapi21',
  // cms: 'https://uateapp.generali.com.hk',
  // api: 'https://uateapp2.generali.com.hk/bravoapi21',
  // cms: 'https://uateapp2.generali.com.hk',
  api: 'https://eapp.generali.com.hk/bravoapi21', 
  cms: 'https://eapp.generali.com.hk',  
  date: {
    dataFormat: "YYYY-MM-DD",
    displayFormat: "MMMM D, YYYY",
  },
  secretKey: "37bO1SVEa8qcyrtHvjrV",
};

export default config;
